import { useAlertasSdc } from 'hooks/sdc/useAlertasSdc'
import React, { useMemo } from 'react'

import { ProntuarioCard } from '../../ProntuarioCard'
import { convertAlertasSdcToRastreamentosModel } from '../utils-rastreamentos'
import { RastreamentosCard } from './RastreamentosCard'

export function RastreamentosSection() {
  const { alertasSdc, loading } = useAlertasSdc()

  const rastreamentos = useMemo(() => convertAlertasSdcToRastreamentosModel(alertasSdc), [alertasSdc])

  const canRender = rastreamentos.length > 0
  const showTooltip = !canRender && !loading

  return (
    <ProntuarioCard title='Rastreamentos' tooltip={showTooltip ? 'Nenhum rastreamento registrado' : undefined}>
      <RastreamentosCard canRender={canRender} loading={false} rastreamentos={rastreamentos} />
    </ProntuarioCard>
  )
}
